export const REPORT_PREVIEW_PAGES = [
  { page: 1, title: 'Cover' },
  { page: 2, title: 'Executive Summary' },
  { page: 3, title: 'Risk & Recommendation' },
  { page: 4, title: 'Business Profile' },
  { page: 5, title: 'Three-year Sales Trend' },
  { page: 6, title: 'Financial Analysis' },
  { page: 7, title: 'Loans & Liabilities Composition' },
  { page: 8, title: 'Payers & Receivables Analysis' },
  { page: 9, title: 'Prime & Kema Approved Payer Metrics' },
  { page: 10, title: 'Receivables Ageing & Payer Concentration' },
  { page: 11, title: 'Risk Scoring Overview' },
  { page: 12, title: 'Conclusion & Recommendation' },
  { page: 13, title: 'Appendix A — Prime Payer Criteria' },
  { page: 14, title: 'Appendix B — Loans & Liabilities' },
  { page: 15, title: 'Appendix C — Prime Payers' },
  { page: 16, title: 'Appendix D — Kema Approved Payers' },
  { page: 17, title: 'Appendix E — Metric Definitions' }
];

export const REPORT_INPUT_PAGE_SECTIONS = [
  { page: 2, title: 'Executive Summary' },
  { page: 3, title: 'Risk & Recommendation' },
  { page: 4, title: 'Business Profile' },
  { page: 5, title: 'Three-year Sales Trend' },
  { page: 6, title: 'Financial Analysis' },
  { page: 8, title: 'Payers & Receivables Analysis' },
  { page: 9, title: 'Prime & Kema Approved Payer Metrics' },
  { page: 10, title: 'Receivables Ageing & Payer Concentration' },
  { page: 11, title: 'Risk Scoring Overview' },
  { page: 12, title: 'Conclusion & Recommendation' },
  { page: 16, title: 'Appendix D — Kema Approved Payers' }
];

export const REPORT_PREVIEW_PAGE_COUNT = REPORT_PREVIEW_PAGES.length;
